export default __webpack_public_path__ + "static/media/back-card.d6a4b999.svg";